import React from 'react';
import Resume from './components/Resume';
import About from './components/About';
import Photos from './components/Photos';
import Videos from './components/Videos';
import Header from './components/Header';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Info from './components/Info';
import './App.css';

function App() {
  return (
    <>
      <Header />
      <main>
        <Info />
        <About />
        <Resume />
        <Videos />
        <Photos />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
